import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Column } from 'react-rainbow-components';
import { orderBy, query } from 'firebase/firestore';
import useExecutions from 'data/firestore/agent/externalautomation/execution/useCollectionWithPagination';
import Table from 'components/Table';
import Pagination from 'components/Pagination';
import DateTimeColumn from 'components/DateTimeColumn';
import { PAGE_SIZE } from '../../../../constants';
import { Container } from '../styled';
import { EntriesText, PaginationContainer } from '../../ExternalAutomationsList/styled';
import PlatformExecutionIdColumn from './columns/platformExecutionId';

const Executions = () => {
    const { agentId = '', externalAutomationId = '' } = useParams();
    const [activePage, setActivePage] = useState(1);

    const {
        data: executions,
        totalRecords: totalExternalAutomations,
        isLoading,
        error,
    } = useExecutions(
        agentId,
        externalAutomationId,
        {
            listQueryFn: (ref) => query(ref, orderBy('createdAt', 'desc')),
            disabled: !agentId || !externalAutomationId,
        },
    );

    const handlePageChange = (event: React.ChangeEvent<unknown>, pageNumber: number) => {
        if (isLoading) return;
        setActivePage(pageNumber);
    };

    const dataToShow = executions || [];
    const totalHits = typeof totalExternalAutomations === 'number' ? totalExternalAutomations : 0;
    const pages = Math.ceil(totalHits / PAGE_SIZE);
    const firstItemOfActivePage = dataToShow.length === 0 ? 0 : PAGE_SIZE * (activePage - 1) + 1;
    const lastItemOfActivePage = Math.min(
        PAGE_SIZE * activePage,
        (PAGE_SIZE * activePage - PAGE_SIZE) + dataToShow.length,
    );

    if (error || (!executions && !isLoading)) {
        return (
            <Container>
                <h1>Something went wrong</h1>
                {error?.message && (
                    <p>
                        {error.name}
                        :
                        {' '}
                        {error.code}
                    </p>
                )}
            </Container>
        );
    }

    return (
        <Container>
            <Table
                data={dataToShow}
                keyField="id"
                sortedBy="createdAt"
                sortDirection="desc"
            >
                <Column
                    header="ID"
                    field="id"
                />
                <Column
                    header="Platform Execution ID"
                    field="platformExecutionId"
                    component={PlatformExecutionIdColumn}
                />
                <Column
                    header="Operations"
                    field="operations"
                />
                <Column
                    header="Created At"
                    field="createdAt"
                    component={DateTimeColumn}
                    sortable
                    width={200}
                />
            </Table>
            <PaginationContainer>
                <EntriesText>
                    Showing
                    {' '}
                    {firstItemOfActivePage}
                    {' '}
                    to
                    {' '}
                    {lastItemOfActivePage}
                    {' '}
                    of
                    {' '}
                    {totalHits}
                    {' '}
                    entries.
                </EntriesText>
                <Pagination
                    activePage={activePage}
                    pages={pages}
                    onChange={handlePageChange}
                />
            </PaginationContainer>
        </Container>
    );
};

export default Executions;
